<template>
  <section class="tab-body">
    <p class="tab-description">
      You have <span class="bold-font">
        {{ pendingRequestCount }} pending request.
      </span>
    </p>

    <!-- modal -->
    <modal v-if="showRequestModal">
      <div slot="header" class="modal-header-content">
        <button type="button" class="btn btn-x" @click="closeRequestModal()">
          X
        </button>
        <div class="modal-title text-center">
          <p>Request pass to</p><h6>{{ passName }}</h6>
        </div>
      </div>

      <div slot="body">
        <div class="detail-title">
          <p>User information</p>
        </div>

        <ul class="detail-content" v-for="(data, index) in includedPassDetails" :key="index + 10">
          <li class="detail-content-title">{{ data }}</li>
          <li class="detail-content-value">
            {{ requestItem.individual_details[constructedIncludedPassDetails[index]] }}
          </li>
        </ul>

        <div class="detail-title">
          <p>Additional details</p>
        </div>

        <div v-for="(r, i) in requestItem.pass_access_questions_response" :key="i">
          <ul class="detail-content">
            <li class="detail-content-title">{{ r.question }}</li>
            <li class="detail-content-value">{{ r.response }}</li>
          </ul>
        </div>

        <div class="detail-title-email">
          <p>Add message to email notification</p>
        </div>

        <div class="detail-title-email-content">
          <p>TEXT FIELD HERE</p>
        </div>
      </div>

      <div slot="footer">
        <button type="button" class="btn btn-cancel"
          @click="closeRequestModal()">Cancel</button>
        <button type="button" class="btn btn-reject"
          @click="updateRequest('Rejected')">Reject</button>
        <button type="button" class="btn btn-approve"
          @click="updateRequest('Accepted')">Approve</button>
      </div>
    </modal>

    <request-list-view
      :requests="requests"
      :hasRequests="hasRequests"
      :showModalRequest="openRequestModal"/>
  </section>
</template>


<script>
import RequestsListView from '@/components/listview/RequestsListView'

import Modal from '@/components/common/Modal'

import { APIService } from '@/api/APIService'

const api = new APIService()

export default {
  components: {
    'request-list-view': RequestsListView,
    Modal
  },
  data() {
    return {
      requestItem: {},
      requests: [],
      passRequestId: '',
      passRequestorEmail: '',
      showRequestModal: false
    }
  },
  props: {
    passName: {
      type: String,
      default: ''
    },
    hasRequests: {
      type: Boolean,
      default: false
    },
    requestsList: {
      type: Array
    },
    includedPassDetails:  {
      type: Array
    }
  },
  computed: {
    constructedIncludedPassDetails () {
      return this.includedPassDetails.map(d => {
        return d.split(' ').length - 1 >= 1
          ? d.toLowerCase().replace(/ /g, '_')
          : d.toLowerCase()
      })
    },
    pendingRequestCount() {
      if(this.requests.length !== 0)
        return this.requests.filter(d => d.request_status === 'Needs approval').length
      else return 0
    }
  },
  watch: {
    requestsList(newVal, oldVal) {
      if(this.requestsList.length === 0) this.requests = this.requestsList
      else {
        this.requests = this.requestsList
        this.sortRequestList()
      }
    }
  },
  mounted() {
    if(this.requestsList.length === 0) this.requests = this.requestsList
    else {
      this.requests = this.requestsList
      this.sortRequestList()
    }
  },
  methods: {
    async updatePassRequestStatus(id, params) {
      await api.updatePassRequestStatus(id, params)
      this.showToastMessage('Pass request status updated!')
      this.sortRequestList()
    },
    sortRequestList() {
      let accepted = []
      let needsApproval = []
      let rejected = []

      this.requests.map(a => {
        if(a.request_status === 'Accepted') accepted.push(a)
        else if(a.request_status === 'Needs approval') needsApproval.push(a)
        else if(a.request_status === 'Rejected') rejected.push(a)
      })

      const acceptedSorted = accepted.sort((a, b) => {
        return a.individual_details.full_name.localeCompare(b.individual_details.full_name)
      })
      const needsApprovalSorted = needsApproval.sort((a, b) => {
        return a.individual_details.full_name.localeCompare(b.individual_details.full_name)
      })
      const rejectedSorted = rejected.sort((a, b) => {
        return a.individual_details.full_name.localeCompare(b.individual_details.full_name)
      })
      this.requests = [...needsApprovalSorted, ...acceptedSorted, ...rejectedSorted]
    },
    openRequestModal(data) {
      this.requestItem = data
      this.passRequestId = data.id
      this.passRequestorEmail = data.requestor_email
      this.showRequestModal = true
    },
    closeRequestModal() { this.showRequestModal = false },
    updateRequest(request) {
      const isAccepted = request === 'Accepted'
      const params = { request_status: request, is_accepted: isAccepted }
      const updated = this.requests.map(i => {
        const temp = Object.assign({}, i)
        if(i.id === this.passRequestId) temp.request_status = request
        return temp
      })
      this.requests = updated
      this.updatePassRequestStatus(this.passRequestId, params)
      this.closeRequestModal()
    },
    showToastMessage(msg) {
      this.$toasted.show(msg, {
      	theme: 'toasted-primary',
      	position: 'top-right',
      	duration : 2000
      })
    },
  }
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tabview/RequestTab.vue